import React from 'react';
import classNames from 'classnames';

import IFormatterEntry from 'common/types/IFormatterEntry';

import './status-badge.scss';

// Maps the various status strings the API returns (rewards, payouts, repair
// tickets, payout addresses) onto a small set of visual tones.
const TONES: Record<string, 'ok' | 'pending' | 'bad' | 'neutral'> = {
  confirmed: 'ok',
  active: 'ok',
  received: 'ok',
  'shipped back': 'ok',
  completed: 'ok',
  paid: 'ok',
  pending: 'pending',
  processing: 'pending',
  'in transit': 'pending',
  repairing: 'pending',
  orphaned: 'bad',
  failed: 'bad',
  rejected: 'bad',
  inactive: 'neutral',
};

const StatusBadge = ({ entry }: IFormatterEntry) => {
  const text = String(entry ?? '');
  const tone = TONES[text.toLowerCase()] ?? 'neutral';

  return (
    <span className={classNames('status-badge', `status-badge--${tone}`)}>
      <span className='status-badge__dot' />
      {text}
    </span>
  );
};

export default StatusBadge;
